<template>
	<v-row>
	
		<!-- Questionário(PeriodoQuest) -->
		<v-col cols="12">
			<v-select density="comfortable" 
        clearable return-object hide-details
        label="Selecione o Questionário..."
				:items="computedPeriodoQuests"
				:item-title="i=> `${!!i && !!i.questionario_object ? i.questionario_object.titulo : 'Selecione o Período avaliativo...'}`"
        v-model="selectedPeriodoQuest"
				@update:modelValue="onChangePeriodoQuest"
				no-data-text="Nenhum período carregado">
				>
        <template v-slot:selection="data">
            <!-- Quando item está selecionado no input v-select  -->
            <span v-html="data.item.title"></span>
        </template>
				<template v-slot:append>
					<v-btn icon
						:loading="$store.state.rh.questionarios_loading"
						@click="get_periodo_quests"
						title="Atualiza Questionários">
						<v-icon>mdi-refresh</v-icon>
					</v-btn>
				</template>
				<template v-slot:item="data">
					<template v-if="!(typeof(data.item.raw) == 'object')">
						<v-list-item-title>-- {{data.item.raw}}</v-list-item-title>
						{{data.item.raw}}
					</template>
					<template v-else>
						<v-hover v-slot="{ isHovering, props }">

							<v-list-item v-bind="{...data.props, ...props }"
                color="primary"
                :key="data.item.value"
                :title="''"
                >
								<v-list-item-title>
                  <div>
                    <span v-html="data.item.raw.questionario_object.titulo"></span>
                  </div>
                  <div>
                      <b class="text-subtitle-2"
                          :class="data.item.raw.periodo_aberto ? 'text-success': 'text-error'">
                          <!-- LEGENDA PERIODO -->
                          {{data.item.raw.periodo_object.descricao}} 
                      </b>
                      <span class="ml-6" v-show="isHovering">
                          <v-icon-small color="primary">mdi mdi-calendar</v-icon-small>
                          <span class="text-subtitle-2 text-primary">{{ data.item.raw.periodo_legenda }}</span>
                          <span class="ml-2">
                              <v-chip size="small" label color="error" v-if="!data.item.raw.periodo_aberto">Indisponível</v-chip>
                              <v-chip size="small" label color="success" v-else>Disponível</v-chip>
                          </span>
                      </span>
                  </div>
								</v-list-item-title>
                <v-list-item-subtitle>
									<!-- <b>{{$verify.truncate(data.item.raw.questionario_object.subtitulo, 100)}} </b> -->
								</v-list-item-subtitle>
							</v-list-item>
						</v-hover>
					</template>
				</template>
			</v-select>
		</v-col>

    <!-- Alerta de Questionário não disponível -->
    <v-col cols="12" class="my-3"
        v-show="selectedPeriodoQuest && 
                selectedPeriodoQuest.id && 
                !selectedPeriodoQuest.periodo_aberto">
        <v-alert color="error">
            <b>
                Questionário selecionado não está disponível. Fora do 
                período de avaliação
            </b>
        </v-alert>
    </v-col>

    <!-- Seleção do Colaborador -->
    <v-col cols="12"
        v-show="selectedPeriodoQuest && 
                selectedPeriodoQuest.id && 
                selectedPeriodoQuest.periodo_aberto">
        
        <!-- v-model:search="search_pessoa"
        @keyup.enter="get_colaboradores" -->
        <v-autocomplete clearable
            ref="search_colaborador"
            density="comfortable"
            label="Selecione Colaborador..."
            :custom-filter="filterColaborador"
            v-model="selectedColaborador"
            @update:modelValue="onChangeColaborador"
            return-object
            :items="computedColaboradores"
            :disabled="$store.state.rh.colaboradores_loading"
            :loading="$store.state.rh.colaboradores_loading"
            item-title="nome"
            item-value="id"
            :no-data-text="$store.state.rh.colaboradores_loading ? 'Carregando colaboradores...' :'Nenhum colaborador carregado'">

            <template v-slot:selection="data">
                <span><b>{{data.item.title}}</b></span>
            </template>

            <template v-slot:item="data">
                <template v-if="!(typeof(data.item.raw) == 'object')">
                </template>
                <template v-else>
                    <v-list-item v-bind="{...data.props }" color="primary" :disabled="data.item.raw.disabled">
                        <v-list-item-title>
                            <div>
                                <b class="text-primary">
                                    {{data.item.raw.alocado_em}}
                                    <v-chip-small label v-if="data.item.raw.disabled" class="text-error"> <b>Avaliado</b> </v-chip-small>
                                </b>
                            </div>
                        </v-list-item-title>
                    </v-list-item>
                </template>
            </template>
        </v-autocomplete>
    </v-col>

    <!-- QUESTIONARIO -->
    <v-col :cols="$vuetify.display.mdAndUp? 10 : 12"
        :offset="$vuetify.display.mdAndUp? 1 : 0"
        v-if="selectedPeriodoQuest &&
                selectedPeriodoQuest.id &&
                selectedColaborador &&
                selectedColaborador.id">

        <v-card class="my-1">
            <v-card-title style="justify-content:center">
              <span v-html="selectedPeriodoQuest.questionario_object.titulo"></span>
            </v-card-title>
            <v-card-text>
                <div class="my-4">
                    <span v-html="selectedPeriodoQuest.questionario_object.subtitulo"></span>
                </div>
                <!-- FOR QUESTOES -->
                <div v-for="formquest, campo_id in selectedPeriodoQuest.questionario_object.questoes"
                    :key="campo_id">
                    <v-divider class="my-3"></v-divider>
                    <!-- HEADER COMPETENCIA -->
                    <v-alert :color="is_ok(formquest) ? '#2A3B4D' : ''"
                        v-if="formquest.competencia">
                        <div>
                            <b>{{campo_id+1}} - {{formquest.competencia.nome}}</b>
                        </div>
                        <div>
                            {{formquest.competencia.descricao}}
                        </div>
                    </v-alert>
                    <!-- TEXTO QUESTAO -->
                    <p class="my-1 px-1 mb-3">
                      <span v-html="formquest.titulo"></span>
                    </p>
                    <span class="font-italic">
                      {{formquest.obrigatoria ? '' : '(Opcional)'}}
                    </span>
                    <!-- QUESTOES 5W2H -->
                    <!-- <pre> {{ formquest }} </pre>  -->
                    <div v-if="(formquest.subquestions || [] ).length" class="ml-6">
                        <div v-for="(subquest, index) in formquest.subquestions" :key="index">                          
                            <span class="fields gdb5w2h">
                              <label> {{ subquest.titulo }}</label>
                              <!-- eslint-disable-next-line -->
                              <quill-editor v-model:content="subquest.resposta"
                                content-type="html"
                                placeholder="..."
                                :toolbar="[]">
                              </quill-editor>
                            </span>
                        </div>
                    </div>
                    <!-- QUESTOES TIPO SUBJETIVA -->
                    <div v-if="formquest.tipo === TEXT">
                        <div v-for="campo, ind in formquest.options" :key="ind">
                            <!-- Atribuir zero a campos de questoes do tipo text -->
                            <label> {{ (formquest.subquestions || [] ).length ? `Considerações` : campo.label }}</label>
                            <span class="fields gdb5w2h">
                              <!-- eslint-disable-next-line -->
                              <quill-editor v-model:content="formquest.value" 
                                content-type="html"
                                :placeholder="(formquest.subquestions || [] ).length ? 'Avaliação...':'Responda aqui...'"
                                :toolbar="[]">
                              </quill-editor>
                            </span>
                        </div>
                    </div>
                    <!-- QUESTOES TIPO OBJETIVA -->
                    <div v-if="formquest.tipo === SINGLE">
                        <div v-for="campo, ind in formquest.options" :key="ind">
                            <v-radio-group v-model="formquest.value" hide-details>
                                <v-radio :label="campo.label" :value="campo.peso"></v-radio>
                            </v-radio-group>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
      <div>
        <!-- 
        <div>
            <span class="my-4">
            {{computedRespondidas}} / {{computedQtdeQuestoes}} Respondidas <br>
              {{computedTotal}} Total 
            </span>
        </div>
        -->
        <div>
            <!-- Bloquear botão quando as respondidas for menor que as obrigatorias ou não houver colaborador selecionado -->
            <v-btn block color="success" class="py-12"
                :disabled="computedRespondidas < computedQtdeQuestoesObrigatorias || !(selectedColaborador && selectedColaborador.id)"
            @click="saveQuestionario">Finalizar</v-btn>
        </div>
      </div>
    </v-col>
    <!-- AVALIADOS E NAO AVALIADOS -->
    <v-col :cols="$vuetify.display.mdAndUp? 10 : 12" :offset="$vuetify.display.mdAndUp? 1 : 0"
      class="my-3" v-if="$verify.eh_gestor_rh() || $verify.eh_lider_avaliador()"
      v-show="selectedPeriodoQuest && selectedPeriodoQuest.id && computedColaboradores.length">
      <v-row>
        <!-- COLABORADORES AVALIADOS -->
        <v-col cols="12">
          <v-expansion-panels multiple>
            <v-expansion-panel>
              <v-expansion-panel-title>
                Colaboradores avaliados
                <template v-slot:actions>
                    <v-chip label small class="mr-2" title="Quantidade de avaliados" color="success">
                        <v-progress-circular
                          v-show="colaboradores_avaliados_loading"
                          size="15" indeterminate color="white" />
                        <b v-show="!colaboradores_avaliados_loading">{{computedColaboradoresAvaliados.length }}</b>
                    </v-chip>
                </template>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="content-avaliacoes">
                <div v-for="colab, i in computedColaboradoresAvaliados"
                  :key="'colab_avaliado_'+i">
                  <v-list-item two-line>
                      <v-list-item-subtitle><b>{{colab.avaliado}}</b></v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <small> Avaliado por: {{colab.avaliado_por}}</small>
                      </v-list-item-subtitle>
                  </v-list-item>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <!-- COLABORADORES NAO AVALIADOS -->
        <v-col cols="12">
          <v-expansion-panels multiple>
            <v-expansion-panel>
              <v-expansion-panel-title>
                Colaboradores não avaliados
                <template v-slot:actions>
                    <v-chip label small class="mr-2" title="Quantidade de não avaliados" color="error">
                      <v-progress-circular
                          v-show="colaboradores_nao_avaliados_loading"
                          size="15" indeterminate color="white" />
                        <b v-show="!colaboradores_nao_avaliados_loading">{{computedColaboradoresNaoAvaliados.length}}</b>
                    </v-chip>
                </template>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="content-avaliacoes">
                <div v-for="colab, i in computedColaboradoresNaoAvaliados"
                  :key="'colab_nao_avaliado_'+i">
                  <span class="text-grey subtitle-2 pl-4">{{colab.nome}}</span>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'RHAvaliar',
  components: {
    },
  props:{
    // id: {
    //   type: String,
    //   required:false
    // }
  },
  data(){
    return {
      search_pessoa: '',
      MIN_LENGTH_SUBJECT_QUESTION: 2,
      SINGLE: 'single',
      TEXT: 'text',
      // questionario: {},
      avaliar:{
        periodoquest: null,
        colaborador: null,
        respostas: null, //JSON
        concluido: false,
        respondidas: 0,
        total: 0
      },
      colaboradores_avaliados:[],
      colaboradores_avaliados_loading: false,
      colaboradores_nao_avaliados:[],
      colaboradores_nao_avaliados_loading: false,
      selectedColaborador: null,
      selectedPeriodoQuest: null,
    }
  },
  methods: {
    resetColaborador(){
      const selectedColab = null
      this.selectedColaborador = selectedColab //Object.assign({}, {})
    },
    resetPeriodoQuest(){
      const selectedPeriodoQuest = null
      this.selectedPeriodoQuest = selectedPeriodoQuest //Object.assign({}, {})
    },
    // Obter colaboradores do gestor logado
    // E, ao selecionar o colaborador, clicar em "Avaliar colaborador"
    async get_periodo_quests(){
        await this.$store.dispatch('GetRHPeriodoQuests')
    },
    async saveQuestionario(){
      const data = {
        periodoquest: this.selectedPeriodoQuest.id,
        colaborador: this.selectedColaborador.id,
        respostas: this.selectedPeriodoQuest.questionario_object.questoes, //JSON
        concluido: this.computedRespondidas >= this.computedQtdeQuestoesObrigatorias,
        respondidas: this.computedRespondidas,
        total: this.computedTotal
      }
      const avaliado = await this.$store.dispatch('RHAvaliarColaborador', data)
      if (!avaliado) return
      // Descomentar para, sempre que avaliar um colaborador, recarregar o PeriodoQuest, caso, em paralelo, haja alguma alteração no questionário
      // this.get_periodo_quests()
      this.get_colaboradores()
      this.get_colaboradores_avaliados()
      this.get_colaboradores_nao_avaliados()
      this.selectedColaborador = this.resetColaborador() //Object.assign({}, {})
      this.selectedPeriodoQuest.questionario_object.questoes.map(obj => {
        // limpar variáveis respondidas de um colaborador após avaliar
        obj.value = null
        return {...obj}
      })
      // Atualizar os setores, inclusive a lista de colaboradores com seus gráficos
      await this.$store.dispatch('GetLocais')
    },
    async get_colaboradores(){
      const selectedColab = null
      this.selectedColaborador = selectedColab
      const params = {
        nome: this.search_pessoa
      }
      await this.$store.dispatch('GetRHColaboradores', params)
      try{
        this.$refs.search_colaborador.focus()
      }catch{
        // console.log('error')
      }
    },
    async get_colaboradores_avaliados(){
      this.colaboradores_avaliados_loading = true
      const existe_questionario_periodo = this.selectedPeriodoQuest && this.selectedPeriodoQuest.id
      const periodoquest_id = existe_questionario_periodo ? this.selectedPeriodoQuest.id : 0
      try{
        const params = {
          periodoquest_id: periodoquest_id,
        }
        const response = await this.$store.dispatch('GetRHAvaliados', params)
        if (response.status == 200) {
          this.colaboradores_avaliados = response.data.results
        }else{
          this.colaboradores_avaliados = []
        }
      }catch(error){
        console.error('falha ao carregar avaliados', error)
      }
      this.colaboradores_avaliados_loading = false
    },
    async get_colaboradores_nao_avaliados(){
      this.colaboradores_nao_avaliados_loading = true
      try{
        const params = {
          periodoquest_id: this.selectedPeriodoQuest && this.selectedPeriodoQuest.id ? this.selectedPeriodoQuest.id : 0,
        }
        const response = await this.$store.dispatch('GetRHNaoAvaliados', params)
        if (response.status == 200) {
          this.colaboradores_nao_avaliados = response.data.results
        } else {
          this.colaboradores_nao_avaliados = []
        }
      }catch(error){
        console.error('falha ao carregar avaliados', error)
      }
      this.colaboradores_nao_avaliados_loading = false
    },
    init(){
      this.get_periodo_quests()
    },
    onChangePeriodoQuest(value){
      if(value && value.id){
        this.get_colaboradores()
        this.get_colaboradores_avaliados()
        this.get_colaboradores_nao_avaliados()
      }
    },
    onChangeColaborador(value){
      if(value && value.id){
        // Limpar alternativas
        this.selectedPeriodoQuest.questionario_object.questoes.map(obj => {
        obj.value = null
        return {...obj}
      })
      }
    },
    filterColaborador(item, queryText, itemText){
      item // titulo do item (nome do colaborador)
      queryText // texto digitado
      itemText // item obj da lista 
      const searchText = (queryText||'').toLowerCase()
      const setor = (itemText.raw.alocado_em||'').toLowerCase().indexOf(searchText) !== -1
      const nome = (itemText.raw.nome||'').toLowerCase().indexOf(searchText) !== -1 
      return setor || nome
    },
    resetForm(){
      // this.selectedColaborador = Object.assign({}, {})
      // this.selectedPeriodoQuest = Object.assign({}, {})
    },
    is_ok(question){
      /*
        is_ok = boolean (está respondida?)
        Altera a cor do label de competencia das questões para
        diferenciar para as que não estão respondidas
      */
      return question.value !== null
    }
  },
  computed:{
    computedRespondidas(){
      const objetivas = (this.selectedPeriodoQuest.questionario_object.questoes||[])
                          .filter(obj =>  obj.tipo === this.SINGLE && 
                                          obj.value !== null &&
                                          obj.obrigatoria
                                        ).length
      const subjetivas = (this.selectedPeriodoQuest.questionario_object.questoes||[])
                          .filter(obj => obj.tipo === this.TEXT &&
                                        // diferentes de null
                                        obj.value !== null &&
                                        obj.obrigatoria
                                        // que haja pelo menos, 2 caracteres
                                        // && (obj.value||'').length > this.MIN_LENGTH_SUBJECT_QUESTION
                                    ).length
      const total_respondidas = objetivas + subjetivas
      return total_respondidas
    },
    computedQtdeQuestoes(){
      return (this.selectedPeriodoQuest.questionario_object.questoes||[]).length
    },
    computedQtdeQuestoesObrigatorias(){
      return (this.selectedPeriodoQuest.questionario_object.questoes||[]).filter(f => f.obrigatoria ).length
    },
    computedTotal(){
      // console.log('computedTotal', this.selectedPeriodoQuest.questionario_object.questoes)
      const questoes = this.selectedPeriodoQuest.questionario_object.questoes
      const questoes_objetivas = (questoes||[])
                                  .filter(obj => obj.tipo === 'single'
                                                  && obj.value !== null)
      // console.log('questoes_objetivas', questoes_objetivas)
      const total_objetivas = questoes_objetivas
                              .reduce((acc, obj) => Number(acc) + Number(obj.value), 0) //soma partindo do zero, os values
      const questoes_subjetivas = (questoes||[])
                                  .filter(obj => obj.tipo === 'text'
                                            && obj.value !== null &&
                                            (obj.value||'').length > this.MIN_LENGTH_SUBJECT_QUESTION
                                          )
      // console.log('questoes_subjetivas', questoes_subjetivas)
      const total_subjetivas = questoes_subjetivas
                                    .reduce((acc, obj) => Number(acc) + Number(obj.peso), 0) //soma partindo do zero, os values
      try{
        return total_objetivas + total_subjetivas
      }catch{
        return null
      }
    },
    computedPeriodoQuests(){
      // Exibir apenas periodos abertos
      return this.$store.state.rh.periodoquests.filter(pq => pq.periodo_aberto)
    },
    computedColaboradores(){
      const colabs = this.$store.state.rh.colaboradores
      // adicionar prop "disabled" para bloquear colaborador que já está avaliado
      return colabs.map(c => ({...c, disabled: this.computedColaboradoresAvaliados.map(a=>a.colaborador).includes(c.id)}))
    },
    computedColaboradoresAvaliados(){
      return this.colaboradores_avaliados
    },
    computedColaboradoresNaoAvaliados(){
      return this.colaboradores_nao_avaliados
    },
  },
  mounted(){
    this.init()
  },
  watch: {
    computedPeriodoQuests: {
      handler(value){
        value
        // Computed em watch necessário para caso haja uma alteração no
        // questionário e, ao voltar para a aba Avaliar, selecionar novamente o questionário(atualizado)
        this.selectedPeriodoQuest = this.resetPeriodoQuest()// Object.assign({}, {})
        this.selectedColaborador = this.resetColaborador()// Object.assign({}, {})
      },
      deep: false //não redefinir quando uma prop, apenas, for alterada
    }
  }
}
</script>

<style scoped>
  .links{
    text-decoration: none;
  }
  .content-avaliacoes{
    max-height: 250px;
    overflow-y: auto;
    padding: 0 !important;
    margin: 15px 5px;
    white-space: nowrap;
  }
</style>
<style>
  .v-expansion-panel-content__wrap{
    padding: 0 !important;
  }
</style>